import { useState, createContext, useEffect } from "react";

export const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [visibleMessageErrorForUser, setVisibleMessageErrorForUser] =
    useState(null);

  //   useEffect(() => {
  //     setVisibleMessageErrorForUser(!visibleMessageErrorForUser);
  //   }, [visibleMessageErrorForUser]);
  return (
    <MessageContext.Provider
      value={{
        setVisibleMessageErrorForUser,
        visibleMessageErrorForUser,
      }}
    >
      {children}
    </MessageContext.Provider>
  );
};
